import React from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ScrollToTopBtn from "../common/ScrollToTop";
import * as reportApi from "../../api/reportApi";

class AccumulatedDataimport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      companies: [],
      years: [],
      companyId: 1,
      year: new Date().getFullYear(),
      month: new Date().getMonth() - 1,
      page: 0,
      rowsPerPage: 10,
      sortDirection: "asc",
    };
  }

  async componentDidMount() {
    try {
      this.getAccumulatedDataimport();
      this.getCompanies();
      this.getYears();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getAccumulatedDataimport = async () => {
    const { companyId, year, month } = this.state;
    const reports = await reportApi.getAccumulatedDataimport(
      companyId,
      year,
      month
    );
    this.setState({ reports: reports || [] });
  };

  getCompanies = async () => {
    const companies = await reportApi.getSupplyingCompanies();
    if (companies) {
      this.setState({ companies });
    }
  };

  getYears = async () => {
    const years = await reportApi.getYears();
    if (years) {
      years.sort((a, b) => b - a);
      this.setState({ years });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleChange = async (e) => {
    const name = e.target.name;
    await this.setState({ [name]: e.target.value });
    this.getAccumulatedDataimport();
  };

  compareBydesc = (key) => (a, b) => (a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0);

  compareByasc = (key) => (a, b) => (a[key] < b[key] ? 1 : a[key] > b[key] ? -1 : 0);

  sortBy = (key) => {
    const { reports, sortDirection } = this.state;
    const sortedReports = [...reports].sort(
      sortDirection === "asc" ? this.compareByasc(key) : this.compareBydesc(key)
    );
    this.setState({
      reports: sortedReports,
      sortDirection: sortDirection === "asc" ? "desc" : "asc",
    });
  };

  render() {
    const { reports, companies, years, companyId, year, month, page, rowsPerPage } = this.state;
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const columns = [
      { id: "caseYear", label: "År", minWidth: 100 },
      { id: "caseMonth", label: "Måned", minWidth: 100 },
      { id: "caseTypeName", label: "Type", minWidth: 100 },
      {
        id: "paidOut",
        label: "Utbetalt",
        align: "right",
        minWidth: 100,
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "paidIn",
        label: "Innbetalt",
        align: "right",
        minWidth: 100,
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "costs",
        label: "Omkostninger",
        align: "right",
        minWidth: 100,
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "reserve",
        label: "Reserve",
        align: "right",
        minWidth: 100,
        format: (value) => value.toLocaleString("de-DE"),
      },
    ];

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={{ width: "100%", paddingTop: 80 }}>
            <Paper style={{ width: "100%", padding: 20 }}>
              <div style={{ marginLeft: 10, paddingTop: 10 }}>
                <h3>Oppsummering av importerte data</h3>
                <Grid container spacing={3}>
                  <Grid item lg={3} md={6} sm={12} xs={12}>
                    <FormControl variant="standard" fullWidth>
                      <InputLabel>Leverandør</InputLabel>
                      <Select
                        name="companyId"
                        value={companyId || ""}
                        onChange={this.handleChange}
                      >
                        {companies.map((company, index) => (
                          <MenuItem key={index} value={company.companyId}>
                            {company.companyName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={3} md={6} sm={12} xs={12}>
                    <FormControl variant="standard" fullWidth>
                      <InputLabel>År</InputLabel>
                      <Select
                        name="year"
                        value={year || ""}
                        onChange={this.handleChange}
                      >
                        {years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={3} md={6} sm={12} xs={12}>
                    <FormControl variant="standard" fullWidth>
                      <InputLabel>Måned</InputLabel>
                      <Select
                        name="month"
                        value={month || ""}
                        onChange={this.handleChange}
                      >
                        {months.map((month, index) => (
                          <MenuItem key={index} value={month}>
                            {month}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
              <Paper style={{ width: "100%", marginTop: 30 }}>
                <div style={{ overflow: "auto" }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column, index) => (
                          <TableCell
                            key={index}
                            align={column.align}
                            style={{ minWidth: column.minWidth, cursor: "pointer", fontWeight: "bold" }}
                            onClick={() => this.sortBy(column.id)}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {reports.length > 0 ? (
                        reports.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((report, index) => (
                          <TableRow key={index} hover>
                            {columns.map((column) => {
                              const value = report[column.id];
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={columns.length} align="center">
                            Ingen treff
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </div>
                <TablePagination
                  rowsPerPageOptions={[10, 50, 100]}
                  component="div"
                  count={reports.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={this.handleChangePage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
              </Paper>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

export default AccumulatedDataimport;
